exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-form-item:last-child {\n  margin-bottom: 0; }\n\n.login-form {\n  padding-top: 24px;\n  padding-bottom: 24px;\n  margin-top: 16px; }\n  .login-form .anticon {\n    color: #808080; }\n  .login-form .ant-btn {\n    width: 100%; }\n\n.login-links {\n  margin-top: 16px; }\n", ""]);

// exports
